<template>
  <LayoutSection :sectionClass="'md:pb-40 sm:pb-[2.5rem]'">
    <FooterMenu :footerMenus="footerMenus" />
  </LayoutSection>
</template>

<script>
import FooterMenu from "@/components/home/sections/footerMenu/footerMenu.vue";
import LayoutSection from "@/components/design/layoutSection.vue";

export default {
  name: "FooterMenuSection",
  components: {
    FooterMenu,
    LayoutSection,
  },
  data() {
    return {
      footerMenus: [
        [
          { text: this.$t("Functional medicine"), link: "#" },
          { text: this.$t("Root-cause focus"), link: "#" },
          { text: this.$t("Whole-person approach"), link: "#" },
          { text: this.$t("Emotional health"), link: "#" },
          { text: this.$t("Personalized care"), link: "#" },
          { text: this.$t("Prevention"), link: "#" },
          { text: this.$t("Holistic well-being"), link: "#" },
          { text: this.$t("Natural therapies"), link: "#" },
          { text: this.$t("Ancestral practices"), link: "#" },
          { text: this.$t("Microbiome health"), link: "#" },
          { text: this.$t("Hormone balance"), link: "#" },
          { text: this.$t("Nervous system regulation"), link: "#" },
          { text: this.$t("Longevity"), link: "#" },
        ],
        [
          { text: this.$t("Phytotherapy"), link: "#" },
          { text: this.$t("Traditional Chinese medicine"), link: "#" },
          { text: this.$t("Hypnotherapy"), link: "#" },
          { text: this.$t("Reflexology"), link: "#" },
          { text: this.$t("Lymphatic drainage"), link: "#" },
          { text: this.$t("Bioresonance"), link: "#" },
          { text: this.$t("Sophrology"), link: "#" },
          { text: this.$t("Somatic movement"), link: "#" },
          { text: this.$t("Aromatherapy"), link: "#" },
          { text: this.$t("Ayurveda"), link: "#" },
          { text: this.$t("Bach flowers"), link: "#" },
          { text: this.$t("EMDR"), link: "#" },
          { text: this.$t("Conscious nutrition"), link: "#" },
        ],
        [
          { text: this.$t("Functional doctor"), link: "#" },
          { text: this.$t("Nutritionist"), link: "#" },
          { text: this.$t("Naturopath"), link: "#" },
          { text: this.$t("Osteopath"), link: "#" },
          { text: this.$t("Homeopath"), link: "#" },
          { text: this.$t("Acupuncturist"), link: "#" },
          { text: this.$t("Health coach"), link: "#" },
          { text: this.$t("Transpersonal psychologist"), link: "#" },
          { text: this.$t("Emotional therapist"), link: "#" },
          { text: this.$t("Biological dentist"), link: "#" },
          { text: this.$t("Kinesiologist"), link: "#" },
          { text: this.$t("Posturologist"), link: "#" },
          { text: this.$t("Integrative gynecologist"), link: "#" },
        ],
      ],
    };
  },
};
</script>

<style scoped></style>
